import React, { useState, useRef, useEffect } from 'react';
import Spinner from '../../Spinner';
import './Forecast.scss';
import { SearchBox } from '@mapbox/search-js-react';
import mapboxgl from 'mapbox-gl';
import locationIcon from '../../../assets/icons/location-icon.png';
import { Cloud } from "@phosphor-icons/react";
import Forecast from './Forecast';
import { useUserContext } from '../../../contexts/UserContext';

export default function ForecastMenu(props) {
    const {
        is3D,
        setIs3D
    } = useUserContext();

    const {
        map
    } = props;

    const locationRef = useRef(null);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [stage, setStage] = useState('menu');
    const [coordinates, setCoordinates] = useState([]);
    const [locationLoading, setLocationLoading] = useState(false);

    useEffect(() => {
        return () => {
            if (locationRef.current) {
                locationRef.current.remove();
            }
        }
    }, [])

    const getLocation = () => {
        setError(false);
        setLocationLoading(true);
        if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const location = [position.coords.longitude, position.coords.latitude];
                 if (location) {
                    setCoordinates(location);
                    map.current.flyTo({ center: location, pitch: 0, zoom: 11 });

                    if (is3D) {
                        setIs3D(false);
                    }

                    if (locationRef.current) {
                        locationRef.current.remove();
                    }

                    const point = document.createElement('div');
                    point.className = 'map-current-location-marker';
                    const marker = new mapboxgl.Marker(point).setLngLat(location).addTo(map.current);
                    locationRef.current = marker;

                    setLocationLoading(false);
                    setStage('forecast');
                }
            },
            (err) => {
                setLocationLoading(false);
                setError('Trouble getting your location. Please try again.');
            }
        );
        } else {
            setLocationLoading(false);
            setError('Trouble getting your location. Please try again.');
        }
    };

    const mainStageSwitch = (stage) => {
        switch (stage) {
            case 'menu':
                return (
                    <div className='forecast-page-content-instructions'>
                        <div className='forecast-page-content-instructions-instruction'>
                            <div className='forecast-page-content-instructions-instruction-title'>Step 1: Choose location</div>
                            <div className='forecast-page-content-instructions-instruction-sub-title'>Option 1: Current Location</div>
                            {locationLoading ?
                            <div style={{ paddingTop: '1rem' }}>
                                <Spinner />
                            </div>
                            :
                            <div 
                                className='forecast-page-content-instructions-instruction-current-location-btn'
                                onClick={getLocation}
                            >
                                <img src={locationIcon} className='forecast-page-content-instructions-instruction-current-location-btn-icon'/>
                                <div 
                                    className='forecast-page-content-instructions-instruction-current-location-btn-text'
                                >Use Current Location
                                </div>
                            </div>}
                            <div className='forecast-page-content-instructions-instruction-sub-title'>Option 2: Search a location</div>
                            <SearchBox
                                accessToken={process.env.REACT_APP_MAPBOX_ACCESS_TOKEN} 
                                value=''
                                onRetrieve={(e) => {
                                    const location = e.features[0].geometry.coordinates;
                                    setCoordinates(location);

                                    setStage('forecast');
                                    map.current.flyTo({center: location, zoom: 11, pitch: 0, offset: [250, 0]});
                                    
                                    if (is3D) {
                                        setIs3D(false);
                                    }
                                }}
                            />
                        </div>
                    </div>
                )
            case 'forecast':
                return (
                    <Forecast 
                        coordinates={coordinates}
                        setMainStage={setStage}
                    />
                )
        }
    }

    return (
        <div 
            className='forecast-page'
            style={stage === 'forecast' ? { width: '600px' } : { }}
        >
            <div className='forecast-page-header'>
                <div className='forecast-page-header-title'>{/* <Cloud size={24} style={{ marginRight: '0.5rem' }}/> */}Forecast</div>
                <div className='forecast-page-header-description'>Stay informed with real-time weather data and trends in your current Monitoring Area, crucial for understanding current conditions.</div>
            </div>
            {mainStageSwitch(stage)}  
        </div>
    )
}